import { LoremIpsum } from 'lorem-ipsum';

import { timeOut } from './util';

function getRandomInteger(minNumber: number, maxNumber: number) {
  const random = Math.random() * (maxNumber - minNumber + 1) + minNumber;
  return Math.floor(random);
}

const lorem = new LoremIpsum({
  sentencesPerParagraph: {
    max: 8,
    min: 4,
  },
  wordsPerSentence: {
    max: 16,
    min: 4,
  },
});

const generateContent = <T extends {}>(
  len: number,
  mapper: (index: number, array: T[]) => T,
): T[] => {
  const result: T[] = [];
  for (let i = 0; i < len; i++) {
    result.push(mapper(i, result));
  }
  return result;
};

const req = async <T extends {}>(
  data: T,
  delay?: number,
): Promise<{
  data: T;
}> => {
  await timeOut(delay || 300);
  return {
    data,
  };
};

const mockupUtils = {
  req,
  getRandomInteger,
  lorem,
  generateContent,
};

export default mockupUtils;
